<template>
  <div class="reg-body">
      <div class="main-image-wrapper" style="background-image: url(&quot;https://us-central1-devil-263810.cloudfunctions.net/images?imageID=btflp8a23akg00bfg3jg.png&quot;);"><div class="main-image-grad"></div></div>
      <form v-if="form" @submit.prevent="sendForm()">
    <h1>TABC OPEN HOUSE REGISTRATION</h1>
    <p>Items with an asterisk (*) are required fields</p>
    <!-- <router-link to="/">I'm Already Registered</router-link> -->
    <div v-for="(group,i) in registration" :key="i">
      <h3>{{group.title}}</h3>
      <label    v-for="(field, i) in group.fields" :key="i">
          {{field.name}}
      <input
      class="w-input"
      @input="logItem($event,field.slug)"
        :type="field.type"
        :placeholder="field.name"
        :v-model="form[field.slug]"
        :required="field.required"
        />
    </label>
    </div>
    <input class="w-button" type="submit" :value="status">
      </form>
      <div v-if="success" class="success-message">
        <p>Your registration has been successfully submitted!</p>
        <i>You will now be redirected to the event page</i>
      </div>
        </div>
</template>

<style scoped>

.main-image-wrapper{
    height: 240px;
}
.reg-body{
    background: #fafafa;
    min-height: 100vh;
    text-align: left;
}
form,.success-message {
    margin: auto;
    background: white;
    display: block;
    padding: 40px;
    max-width: 670px;
    width: 95%;
    margin-top: 200px;
    position: relative;
    z-index: 3;
    border-radius: 5px;
}
.success-message{
  color:#29b366;
  text-align: center;
  font-weight: 600;
}
.w-button{
  border-radius: 100px;
  padding: 7px 40px;
  display: inline-block;
  
}
@media screen and (max-width: 768px) {
  .main-image-wrapper{
    height: 120px;
}
form {
     margin-top: 100px;
}
}
</style>

<script>
import Bagel from "@bageldb/bagel-db";
export default {
  methods:{
    logItem(event,slug){
      this.form[slug]=event.target.value
    },
    async sendForm(){
        this.status = "sending..."
    // let token = tokens.find((t) => t.siteURL == this.site).token;
    let db = new Bagel(process.env.VUE_APP_BAGEL_TOKEN);
    await db.collection("tabcRegistrations").post(this.form);
 
    window.scrollTo(0, 0);
    this.success = true;
    this.form = false;

    setTimeout(()=>this.$router.push("/"),4500)
    
    }
  },
  mounted(){
    if (!window.location.href.match("tabc")&&process.env.NODE_ENV!="development") {
      this.$router.push("/")
    }
    let form = {}
    for (const group of this.registration){
      for (const field of group.fields){
        form[field.slug] = ""
      }
    }
    
    this.form = form;
  },
  data() {
    return {
      success:false,
      site: "jewish",
      form: false,
      status:"",
      registration: [
        {
          title: "STUDENT INFORMATION",
          fields: [
            {
              name: "First Legal Name*",
              type: "text",
              required:true,
              slug:"firstLegalName"
            },
            {
              name: "First Preferred Name*",
              type: "text",
              required:true,
              slug:"firstPreferredName"
            },
            {
              name: "Last Name*",
              type: "text",
              required:true,
              slug:"lastName"
            },
            {
              name: "Student Email",
              type: "email",
              slug:"studentEmail"
            },
            // {
            //   name: "Student Cell Phone",
            //   type: "text",
            //   slug:"studentCellPhone"
            // },
            {
              name: "Current Middle School*",
              type: "text",
              required:true,
              slug: "currentMiddleSchool",
            },
          ],
        },
        {
          title: "HOME ADDRESS",
          fields: [
            {
              name: "Address*",
              type: "text",
              required:true,
              slug: "address",
            },
            {
              name: "City*",
              type: "text",
              required:true,
              slug: "city",
            },
            {
              name: "State*",
              type: "text",
              required:true,
              slug: "state",
            },
            {
              name: "Zip Code*",
              type: "text",
              required:true,
              slug:"zipCode"
            },
          ],
        },
        {
          title: "MOTHER",
          fields: [
            {
              name: "Title*",
              type: "text",
              required:true,
              slug:"motherTitle"
            },
            {
              name: "First Name*",
              type: "text",
              required:true,
              slug:"motherFirstName"
            },
            {
              name: "Last Name*",
              type: "text",
              required:true,
              slug:"motherLastName"
            },
            // {
            //   name: "Address (If Different from Student's address)",
            //   type: "text",
            //   slug:"motherAddress"
            // },
            {
              name: "Email*",
              type: "email",
              required:true,
              slug:"motherEmail"
            },
            // {
            //   name: "Home Phone",
            //   type: "tel",
            //   slug:"motherHomePhone"
            // },
            // {
            //   name: "Cell Phone",
            //   type: "tel",
            //   slug:"motherCellPhone"
            // },
          ],
        },
        {
          title: "FATHER",
          fields: [
            {
              name: "Title*",
              type: "text",
              required:true,
              slug:"fatherTitle"
            },
            {
              name: "First Name*",
              type: "text",
              required:true,
              slug:"fatherFirstName"
            },
            {
              name: "Last Name*",
              type: "text",
              required:true,
              slug:"fatherLastName"
            },
            // {
            //   name: "Address (If Different from Student's address)",
            //   type: "text",
            //   slug:"fatherAddress"
            // },
            {
              name: "Email*",
              type: "email",
              required:true,
              slug:"fatherEmail"
            },
            // {
            //   name: "Home Phone",
            //   type: "tel",
            //   slug:"fatherHomePhone"
            // },
            // {
            //   name: "Cell Phone",
            //   type: "tel",
            //   slug:"fatherCellPhone"
            // },
          ],
        },
      ],
    };
  },
};
</script>